<div style="height: calc(100vh - 127px); margin: -20px;">
    <app-document-viewer [loadingData]="loading" [filterByDate]="true" (filterChange)="onFilterChange($event)">
                <div class="kpi-card" style="margin-top: 10px;">
                    <div class="chart-panel pie-chart-container">
                        <h3>Oil Collected</h3>
                        <wj-flex-pie #flexPie [itemsSource]="oilData" binding="value" bindingName="name" [innerRadius]="0.7">
                            <wj-flex-pie-data-label [position]="'None'" content="{name}" fontSize="10px"></wj-flex-pie-data-label>
                        </wj-flex-pie>
                    </div>
                    <div class="chart-panel pie-chart-container">
                        <h3>Payments</h3>
                        <wj-flex-pie #flexPie2 [itemsSource]="paymentData" binding="value" bindingName="name" [innerRadius]="0.7">
                            <wj-flex-pie-data-label content="{name}" position="None"></wj-flex-pie-data-label>
                        </wj-flex-pie>
                    </div>
                </div>
                <div class="grid-container table-container">
                     <table class="w-100" style="grid-column: span 2; height: fit-content;">
                        <thead>
                            <tr>
                                <th>PKI</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of pkiOperativesData">
                                <td style="width: 70%;">{{ item.pki }}</td>
                                <td style="width: 30%;">{{ item.value }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="w-100" style="grid-column: span 1; height: fit-content;">
                        <thead>
                            <tr>
                                <th class="header-with-bubble">Restaurants Pending Installation <span class="bubble">{{restaurants.length}}</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of restaurants">
                                <td style="width: 100%;">{{ item }}</td>
                            </tr>
                        </tbody>
                    </table>

                    

                   
                </div>
                 <div class="grid-container table-container">
                    <table class="w-100" style="grid-column: span 1; height: fit-content;">
                        <thead>
                            <tr>
                                <th>Installations Per Person</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of installationsPerPerson">
                                <td style="width: 80%;">{{ item._id }}</td>
                                 <td style="width: 20%;">{{ item.installations }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="w-100" style="grid-column: span 1; height: fit-content;">
                            <thead>
                                <tr>
                                    <th># Tanks Installed By Size</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tanksInstallationsBySize">
                                    <td style="width: 80%;">{{ item?._id }}</td>
                                    <td style="width: 20%;">{{ item?.installations }}</td>
                                </tr>
                            </tbody>
                        </table> 
                 </div>
                <div class="grid-container table-container"> 
                    <table class="w-100" style="grid-column: span 1; height: fit-content;">
                        <thead>
                            <tr>
                                <th>Pending Installations By Vendor</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of pendingInstallationsPerPerson">
                                <td style="width: 80%;">{{ item.name }}</td>
                                 <td style="width: 20%;">{{ item.pending_installations }}</td>
                            </tr>
                        </tbody>
                    </table>

                        <table class="w-100" style="grid-column: span 1; height: fit-content;">
                        <thead>
                            <tr>
                                <th class="header-with-bubble">Restaurants Outdated Installation <span class="bubble">{{restaurantsOutdatedInstallation.length}}</span> </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of restaurantsOutdatedInstallation">
                                <td class="ellipsis-cell">{{ item }}</td>
                            </tr>
                        </tbody>
                    </table></div>

    </app-document-viewer>
</div>